import createReducer from '@epi-helpers/CreateReducer';
import { ApiConstants, BeneficiaryConstants } from '@epi-constants/actions';
import { IBenefitGroupSettings } from '@epi-models/pages/Beneficiaries';

interface BenefitGroupSettingsState {
  benefitGroupSettings: IBenefitGroupSettings[];
  activeBenefits: string[];
  isActiveBenefitsLoaded: boolean;
  isLoaded: boolean;
  isOrderInProgress: boolean;
  goToPageLink: string;
}

const initialState: BenefitGroupSettingsState = {
  benefitGroupSettings: [],
  activeBenefits: [],
  isActiveBenefitsLoaded: false,
  isLoaded: false,
  isOrderInProgress: false,
  goToPageLink: ''
};

export default createReducer(() => initialState, {
  [`${ApiConstants.BENEFIT_GROUP_SETTINGS}_SUCCESS`]: (
    _,
    { payload }: { payload: any[] }
  ) => ({
    benefitGroupSettings: payload,
    isLoaded: true
  }),
  [`${ApiConstants.GET_ACTIVE_BENEFITS}_SUCCESS`]: (
    state: BenefitGroupSettingsState,
    { payload }: { payload: any[] }
  ) => ({
    ...state,
    activeBenefits: payload.map(benefit => benefit.toLowerCase()),
    isActiveBenefitsLoaded: true
  }),
  [`${ApiConstants.LOGOUT_ACTION}_SUCCESS`]: () => initialState,
  [`${ApiConstants.BENEFIT_GROUP_SETTINGS}_FAILURE`]: () => initialState,
  [`${BeneficiaryConstants.START_ORDER_PROCESS}`]: (
    state: BenefitGroupSettingsState
  ) => ({
    ...state,
    isOrderInProgress: true
  }),
  [`${BeneficiaryConstants.STOP_ORDER_PROCESS}`]: (
    state: BenefitGroupSettingsState
  ) => ({
    ...state,
    isOrderInProgress: false
  }),
  [`${BeneficiaryConstants.GO_TO_PAGE_LINK}`]: (
    state: BenefitGroupSettingsState,
    { payload }: { payload: string }
  ) => ({
    ...state,
    goToPageLink: payload
  })
});
